import { motion } from "framer-motion"
import styles from './Catalog.module.scss'
import Packages from '../CatalogItems/Packages/Packages'



const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}



const Catalog = () => {




    return (
        <motion.section 
            className={styles.main}
            id='mono'
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.1, once: true}}
            >
            <div className={styles.box}>
                <motion.h2 className={styles.title} variants={titleAnimation}>каталог нашей продукции
                </motion.h2>
                <div className={styles.box_info}>
                    <Packages/>
                </div>
            </div>
        </motion.section>
    )
}

export default Catalog